import React from 'react';
import { useLocation } from 'react-router-dom';

const BlogArticle1 = () => {

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const vlog = searchParams.get("vlog") || "";
  const title = searchParams.get("title") || "";
  const description = searchParams.get("description") || "";
  return (
    <div className="container mx-auto px-4 py-16">
      {/* Image Section */}
      <div className="mb-8 w-3/5 mx-auto">
      <img
                className="object-cover w-full rounded-lg"
                src={`${vlog}`}
                alt={title} // Replace with actual image file name if available in the /images folder
              />
      </div>

      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      <p className="text-lg text-gray-600 mb-6">
      {description}
      </p>

      {/* <h2 className="text-2xl font-semibold mb-4">Choose Birthday Planner for Birthday Decoration in Gurgaon</h2>
      <p className="text-lg text-gray-600 mb-6">
        Here’s why choosing a birthday planner for your decorations in Gurgaon is a smart move:
      </p>

      <h3 className="text-xl font-semibold mb-2">Professional Expertise at Your Service</h3>
      <p className="text-lg text-gray-600 mb-4">
        Birthday planners know what works. From trendy balloon arches to themed backdrops, they bring expertise and creative ideas that align with your vision. Whether it’s a magical unicorn party for kids or an elegant milestone celebration for adults, they ensure the decorations reflect the mood you’re going for.
      </p>

      <h3 className="text-xl font-semibold mb-2">Save Time and Energy</h3>
      <p className="text-lg text-gray-600 mb-4">
        Life in Gurgaon can be hectic, and planning a birthday party adds to the workload. By hiring a planner, you save yourself the time and effort of running around for supplies, coordinating setups, and managing last-minute changes. Let the experts handle the heavy lifting while you focus on enjoying the celebration.
      </p>

      <h3 className="text-xl font-semibold mb-2">Customization Made Easy</h3>
      <p className="text-lg text-gray-600 mb-4">
        Want a jungle safari theme? Or maybe something minimalist and classy? Birthday planners specialize in bringing your ideas to life. They customize every detail—from the table settings to the photo booths—to ensure your party feels personal and special.
      </p>

      <h3 className="text-xl font-semibold mb-2">Budget-Friendly Solutions</h3>
      <p className="text-lg text-gray-600 mb-4">
        Think hiring a planner is expensive? Not necessarily. A professional birthday planner in Gurgaon works within your budget to deliver stunning results. They know where to source affordable decorations without compromising on quality, giving you the best bang for your buck.
      </p>

      <h3 className="text-xl font-semibold mb-2">Access to the Best Resources</h3>
      <p className="text-lg text-gray-600 mb-4">
        With their network of trusted vendors and suppliers, planners ensure top-quality materials and timely execution. From vibrant balloons to intricate floral arrangements, they bring together elements that make your party shine.
      </p>

      <h3 className="text-xl font-semibold mb-2">A Stress-Free Celebration</h3>
      <p className="text-lg text-gray-600 mb-6">
        The biggest perk of hiring a birthday planner is peace of mind. They handle everything—from setting up the venue to managing decor changes—allowing you to relax and enjoy the celebration with your guests.
      </p>

      <h3 className="text-xl font-semibold mb-2">Read Also: Simple Anniversary Decoration Ideas at Home</h3>

      <h2 className="text-2xl font-semibold mb-4">Why Gurgaon is Ideal for Hiring Birthday Planners</h2>
      <p className="text-lg text-gray-600 mb-6">
        Gurgaon is home to creative and experienced event planners who understand modern trends and aesthetics. Their local expertise ensures your party looks stylish and perfectly suited to your preferences, whether you’re hosting a gathering at home or at a venue.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Let the Experts Handle It</h2>
      <p className="text-lg text-gray-600 mb-6">
        Hiring a birthday planner for decorations in Gurgaon isn’t just about convenience—it’s about creating a celebration that’s beautifully memorable. So, if you’re planning a birthday, let a professional bring your ideas to life while you enjoy every moment of the day.
      </p>

      <p className="text-lg text-gray-600 mb-6">
        Make your next birthday unforgettable—connect with a birthday planner today!
      </p> */}
    </div>
  );
};

export default BlogArticle1;
